// extracted by mini-css-extract-plugin
export default {"wrapper":"u2N9w4PeGh3eYtKyspvE","top":"_bPTSAGtO1UaCz8he2ky","size":"lkImVURpiNXcxHpo6Cna","spin":"aFZ1ikwLT8gsmLtwHfIV"};